import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-event-count',
    templateUrl: './editor-eligibility-rule-form-has-event-count.component.html',
    styleUrls: ['./editor-eligibility-rule-form-has-event-count.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasEventCountComponent implements OnInit {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  eventTypeGroupNames: { id: string, name: string }[];
  comparisonNames: { id: string, name: string }[] = [
    { id: 'eq', name: $localize `Equal to` },
    { id: 'lt', name: $localize `Fewer than` },
    { id: 'lte', name: $localize `Fewer than or equal to` },
    { id: 'gt', name: $localize `More than` },
    { id: 'gte', name: $localize `More than or equal to` },
  ];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.eventTypeGroupNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        eventTypeGroupNames => {
          this.eventTypeGroupNames = eventTypeGroupNames;
        }
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getBlueprintsFormArray(): FormArray {
    return this.formGroup.get('blueprints') as FormArray;
  }
}
